import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "antialiased" }
const _hoisted_2 = { class: "sticky top-0 z-40 border-b bg-background/80 backdrop-blur-md" }
const _hoisted_3 = { class: "flex h-14 items-center gap-2 px-4" }
const _hoisted_4 = { class: "ml-auto flex items-center gap-2" }

import { inject, onBeforeUnmount, onMounted } from 'vue'
import { Moon, Sun } from 'lucide-vue-next'
import { Button } from '@/components/ui/button'
import { SidebarInset, SidebarProvider, SidebarTrigger } from '@/components/ui/sidebar'
import { TooltipProvider } from '@/components/ui/tooltip'
import { useTheme } from '../../utils/useTheme'
import IdpSidebar from './IdpSidebar.vue'
import ViewAsBanner from './ViewAsBanner.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'IdpLayout',
  setup(__props) {

const theme = inject('theme', useTheme())

// On <body>, not a wrapper: sheets, selects and tooltips portal there.
onMounted(() => document.body.classList.add('idp-theme'))
onBeforeUnmount(() => document.body.classList.remove('idp-theme'))

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(TooltipProvider), { "delay-duration": 150 }, {
      default: _withCtx(() => [
        _createVNode(_unref(SidebarProvider), null, {
          default: _withCtx(() => [
            _createVNode(IdpSidebar),
            _createVNode(_unref(SidebarInset), { class: "min-w-0" }, {
              default: _withCtx(() => [
                _createVNode(ViewAsBanner),
                _createElementVNode("header", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_unref(SidebarTrigger), { class: "-ml-1" }),
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_unref(Button), {
                        variant: "ghost",
                        size: "icon-sm",
                        "aria-label": _unref(theme).isDark.value ? 'Switch to light mode' : 'Switch to dark mode',
                        onClick: _unref(theme).toggleTheme
                      }, {
                        default: _withCtx(() => [
                          (_unref(theme).isDark.value)
                            ? (_openBlock(), _createBlock(_unref(Sun), { key: 0 }))
                            : (_openBlock(), _createBlock(_unref(Moon), { key: 1 }))
                        ]),
                        _: 1
                      }, 8, ["aria-label", "onClick"])
                    ])
                  ])
                ]),
                _createVNode(_component_router_view)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})